import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./../styles/login.css";
import { ClipLoader } from "react-spinners";
import { login } from "../api/auth.api";
import { useAuth } from "../context/AuthContext";
import { useUser } from "../context/UserContext";
import { IoEye } from "react-icons/io5";
import { IoEyeOff } from "react-icons/io5";
import ToastNotification, { showTopCenterToast } from "../components/toasts/ToastNotification";
import { adminRoles } from "../utils";

const Login = () => {
  const { authenticatedUser } = useAuth();
  const { user } = useUser();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const reg = searchParams.get('reg');
  const redirect = searchParams.get("redirect");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isDisplay, setIsDisplay] = useState(false);

  const normalizeRole = (role) => String(role || "").trim().toLowerCase();

  useEffect(() => {
    if (user) {
      const currentRole = normalizeRole(user?.role);
      if (adminRoles.includes(currentRole)) {
        navigate("/super-admin/dashboard");
      } else {
        navigate("/");
      }
    }
    document.title = "Đăng nhập";

    const storedTheme = localStorage.getItem("theme");
    if (storedTheme === "dark") {
      document.body.classList.add("dark-theme");
    } else {
      document.body.classList.remove("dark-theme");
    }
  }, [navigate, user]);

  useEffect(() => {
    if (reg) {
      showTopCenterToast("Đăng kí thành công. Vui lòng đăng nhập!", "success");
    }
  }, [reg]);

  const getSafeRedirectPath = (value) => {
    if (!value || typeof value !== "string") return null;
    const decoded = decodeURIComponent(value);
    if (!decoded.startsWith("/")) return null;
    if (decoded.startsWith("//")) return null;
    return decoded;
  };

  const handleLogin = async (e) => {
    try {
      e.preventDefault();
      setError(null);
      setLoading(true);

      if (username === " " && password === " ") {
        setLoading(false);
        showTopCenterToast("Vui lòng điền vào các trường", "error");
        return;
      }
      const res = await login(username, password);
      const loginData = res?.data || {};
      const loggedInUser = loginData?.user;
      const accessToken = loginData?.accessToken;
      if (!loggedInUser) {
        throw new Error("Không lấy được thông tin người dùng sau đăng nhập");
      }

      // Checking banned
      if (loggedInUser?.isBanned) {
        navigate('/banned');
        return;
      }

      authenticatedUser(loggedInUser);
      if (accessToken) {
        localStorage.setItem("accessToken", accessToken);
      }

      const currentRole = normalizeRole(loggedInUser?.role);
      const safeRedirect = getSafeRedirectPath(redirect);
      if (adminRoles.includes(currentRole)) {
        navigate(safeRedirect || "/super-admin/dashboard");
      } else navigate(safeRedirect || "/?redirect=true");

    } catch (error) {
      showTopCenterToast(error.message, "error");
    }
    finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <ToastNotification />
      <div className="login-box">
        <h2 className="login-title">Đăng nhập</h2>
        {/* <p className="login-second-title">Chào mừng đến với thế giới game</p> */}

        {error && <p className="error-text">*{error.message}</p>}
        <form onSubmit={handleLogin}>
          <div className="input-group">
            <input
              type="text"
              placeholder="Tên đăng nhập"
              value={username}
              onChange={(e) => setUsername(e.target.value.trim())}
              required
              className="login-input"
            />
          </div>
          <div className="input-group">
            <div className="password-input-container">
              <input
                type={`${isDisplay ? "text" : "password"}`}
                placeholder="Mật khẩu"
                value={password}
                onChange={(e) => setPassword(e.target.value.trim())}
                required
                className="login-input"
              />
              {!isDisplay ?
                <IoEye onClick={() => setIsDisplay(!isDisplay)} className="eye-pw-icon" />
                :
                <IoEyeOff onClick={() => setIsDisplay(!isDisplay)} className="eye-pw-icon" />}
            </div>
          </div>


          <p className="reset-password">
            <a className="reset-password-text" href="/forgot-password">Quên mật khẩu</a>
          </p>

          <button type="submit" disabled={loading} className={`login-button ${loading ? "disabled-btn" : ""}`}>
            {loading ? <ClipLoader size={20} color="#fff" /> : <i className="fas fa-arrow-right login-icon"></i>}
          </button>
        </form>

        <p className="register-text">
          Bạn chưa có tài khoản? <a href="/register">Đăng kí ngay</a>
        </p>
        <a className="back-to-dashboard-button" href="/">
          ← Quay về trang chủ
        </a>
      </div>
    </div>
  );
};

export default Login;
